<template>
  <img
    :class="[{ language: type === 'languageSpecific' }]"
    :title="`${appTranslate(type)} ${appTranslate('property', undefined, 'lowercase')} (${translate(country || language, translationNamespace)})`"
    :src="getFlag(country, language)"
    :alt="country || language"
  />
</template>

<script lang="ts" setup>
import { useTools } from '@/composables/useTools'
import { useTranslation } from '@/composables/useTranslation'
import { Country, Language } from '@/models/Global'
import { computed } from 'vue'

const props = defineProps<{
  country?: Country
  language?: Language
}>()

const { translate, appTranslate } = useTranslation()
const { getFlag } = useTools()

const type = computed(() => (props.language ? 'languageSpecific' : 'countrySpecific'))
const translationNamespace = computed(() => (type.value === 'languageSpecific' ? 'languages' : 'countries'))
</script>

<style lang="scss" scoped>
img {
  user-select: none;
}
</style>
